import NavigationComponent from "../../navigation/navigation.component";
import { Background, Header1, FlexContainer, Play, Header2, RemoteImg, GifContainer, TVChannelContainer, TVDisplay, TVDisplayLogo, SubContainer, PageLink, TV, TestImg, TVImage, Gradient, OppGradient} from "./programmingprojects.styles";
import febgif from '../../images/games/FEB.gif'
import alchemygif from '../../images/games/Alchemy.gif'
import bizzybrie from '../../images/games/bizzy-brie-small.png'
import { TVContext } from "../../contexts/tv-channels.context";
import { useContext } from "react";

import tvimage from '../../images/games/BizzyBrieTV.png';
import heart4 from '../../images/games/hearts4.png';
import { WordPlayContext } from "../../contexts/word-play.context";
import oozgif from '../../images/games/oozfestation.gif';
 import remoteimg from '../../images/games/BizzyBrieRemote.png'
import { Link } from "react-router";

const ProgrammingProjects = () => {
    const {currentChannel, setCurrentChannel} = useContext(TVContext);
    const {thisWebsite, setThisWebsite} = useContext(WordPlayContext);
    

    const CHANNELS = {
        default: bizzybrie,
        febgif: febgif,
        alchemygif: alchemygif
    }

    const handleMouseEnter = (event) => {
        setThisWebsite("To The Home Page")
        
    }

    const handleMouseLeave = (event) => {
        setThisWebsite("~This Very Website~")
    }
    
    
    return (
        <Background>
            <NavigationComponent></NavigationComponent>
            <Gradient></Gradient>
            <TV>
                
                    <TVImage src={tvimage}></TVImage>
                    {(currentChannel==bizzybrie) ? (<TVDisplayLogo src={currentChannel}></TVDisplayLogo>
                    ) : (<TVDisplay src={currentChannel}></TVDisplay>)
                    }    
            </TV>
            <FlexContainer>
                <Header1>Game Design</Header1>
                <SubContainer>
                    <GifContainer>
                        <Header2><PageLink to="/programming-projects/fall-english-breggfest">Fall English Breggfast</PageLink></Header2>
                        <Play src={heart4}onClick={() => setCurrentChannel(febgif)}></Play>
                    </GifContainer>
                    <GifContainer>
                        <Header2><PageLink to="/programming-projects/alchemy">Alchemy</PageLink></Header2>
                        <Play src={heart4}onClick={() => setCurrentChannel(alchemygif)}></Play>
                    </GifContainer>
                    <GifContainer>
                        <Header2><PageLink to='/programming-projects/oozefestation'>Ooze-festation</PageLink></Header2>
                        <Play src={heart4}onClick={() => setCurrentChannel(oozgif)}></Play>
                    </GifContainer>
                        

                </SubContainer>
                <Header1>Front End Development</Header1>
                <SubContainer>
                    <Header2 onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}><PageLink to="/">{thisWebsite}</PageLink></Header2>
                    <Header2><PageLink to='/programming-projects/maidrpg'>Maid RPG Character Sheet</PageLink></Header2>
                    <Header2><PageLink to='/programming-projects/responsiveweb'>Responsive Web Design Certification Projects</PageLink></Header2>
                </SubContainer>
                <Header1>Website Design</Header1>
                <SubContainer>
                    <Header2><PageLink to='/programming-projects/epiphany-dice'>Epiphany Dice</PageLink></Header2>
                </SubContainer>
            </FlexContainer>
            <OppGradient></OppGradient>
        </Background>
    )
}

export default ProgrammingProjects;